const DATAPRIVACY_FPTI = {
  DAR: {
    IMPRESSION: {
      pgrp: 'main:dataprivacy:downloaddata',
      page: 'main:dataprivacy:downloaddata',
    },
    ACTIVITY_DOWNLOAD: {
      pgrp: 'main:dataprivacy:downloaddata',
      page: 'main:dataprivacy:downloaddata',
      link: 'go_to_activity',
    },
    SELECTALL_LNK: {
      pgrp: 'main:dataprivacy:downloaddata',
      page: 'main:dataprivacy:downloaddata',
      link: 'select_all',
    },
    UNSELECTALL_LNK: {
      pgrp: 'main:dataprivacy:downloaddata',
      page: 'main:dataprivacy:downloaddata',
      link: 'unselect_all',
    },
    SUBMIT_BTN: {
      pgrp: 'main:dataprivacy:downloaddata',
      page: 'main:dataprivacy:downloaddata',
      link: 'submit',
      field_list: '',
      file_frmt: '',
    },
    CHECKBOX: {
      pgrp: 'main:dataprivacy:downloaddata',
      page: 'main:dataprivacy:downloaddata',
      link: [],
    },
    FILETYPE: {
      pgrp: 'main:dataprivacy:downloaddata',
      page: 'main:dataprivacy:downloaddata',
      link: [],
    },
    SUCCESS_IMPRESSION: {
      pgrp: 'main:dataprivacy:downloaddata:success',
      page: 'main:dataprivacy:downloaddata:success',
    },
    SUCCESS_DONE: {
      pgrp: 'main:dataprivacy:downloaddata:success',
      page: 'main:dataprivacy:downloaddata:success',
      link: 'done',
    },
    DAR_OTHER_INFO: {
      pgrp: 'main:dataprivacy:downloaddata:otherinfo',
      page: 'main:dataprivacy:downloaddata:otherinfo',
    },
    DAR_OTHER_INFO_HOVER: {
      pgrp: 'main:dataprivacy:downloaddata:otherinfotooltip',
      page: 'main:dataprivacy:downloaddata:otherinfotooltip',
    },
  },
  DAR_HISTORY: {
    IMPRESSION: {
      pgrp: 'main:dataprivacy:datarequest',
      page: 'main:dataprivacy:datarequest',
    },
    CREATENEW_BTN: {
      pgrp: 'main:dataprivacy:datarequest',
      page: 'main:dataprivacy:datarequest',
      link: 'create_new',
    },
    DOWNLOAD_BTN: {
      pgrp: 'main:dataprivacy:datarequest',
      page: 'main:dataprivacy:datarequest',
      link: 'download',
    },
  },
  CORRECTION: {
    IMPRESSION: {
      pgrp: 'main:dataprivacy:datacorrection',
      page: 'main:dataprivacy:datacorrection',
    },
    SETTINGS_BTN: {
      pgrp: 'main:dataprivacy:datacorrection',
      page: 'main:dataprivacy:datacorrection',
      link: 'gotosetting',
    },
    WALLET_BTN: {
      pgrp: 'main:dataprivacy:datacorrection',
      page: 'main:dataprivacy:datacorrection',
      link: 'gotowallet',
    },
    BUSINESS_INFO_BTN: {
      pgrp: 'main:dataprivacy:datacorrection',
      page: 'main:dataprivacy:datacorrection',
      link: 'gotobusiness',
    },
    ACCOUNT_INFO_BTN: {
      pgrp: 'main:dataprivacy:datacorrection',
      page: 'main:dataprivacy:datacorrection',
      link: 'gotoaccount',
    },
    MONEY_BANK_INFO_BTN: {
      pgrp: 'main:dataprivacy:datacorrection',
      page: 'main:dataprivacy:datacorrection',
      link: 'gotofinance',
    },
  },
  DELETION: {
    IMPRESSION: {
      pgrp: 'main:dataprivacy:datadelettion',
      page: 'main:dataprivacy:datadelettion',
    },
    PRIVACY_LINK: {
      pgrp: 'main:dataprivacy:datadelettion',
      page: 'main:dataprivacy:datadelettion',
      link: 'privacy_policy',
    },
    CONTACTUS_LINK: {
      pgrp: 'main:dataprivacy:datadelettion',
      page: 'main:dataprivacy:datadelettion',
      link: 'contact_us',
    },
    CONTINUE_BTN: {
      pgrp: 'main:dataprivacy:datadelettion',
      page: 'main:dataprivacy:datadelettion',
      link: 'delete_continue',
    },
    EMAIL_IMPRESSION: {
      pgrp: 'main:dataprivacy:datadelettion:email',
      page: 'main:dataprivacy:datadelettion:email',
    },
    EMAILCONTINUE_BTN: {
      pgrp: 'main:dataprivacy:datadelettion:email',
      page: 'main:dataprivacy:datadelettion:email',
      link: 'continue',
    },
    SETTINGS_LINK: {
      pgrp: 'main:dataprivacy:datadelettion:email',
      page: 'main:dataprivacy:datadelettion:email',
      link: 'go_to_settings',
    },
    FEEDBACK_IMPRESSION: {
      pgrp: 'main:dataprivacy:datadelettion:survey',
      page: 'main:dataprivacy:datadelettion:survey',
    },
    CHECKBOX: {
      pgrp: 'main:dataprivacy:datadelettion:survey',
      page: 'main:dataprivacy:datadelettion:survey',
      link: [],
    },
    SUBMIT_BTN: {
      pgrp: 'main:dataprivacy:datadelettion:survey',
      page: 'main:dataprivacy:datadelettion:survey',
      link: 'submit',
    },
    SUCCESS_IMPRESSION: {
      pgrp: 'main:dataprivacy:datadelettion:success',
      page: 'main:dataprivacy:datadelettion:success',
    },
    SUCCESS_DONE: {
      pgrp: 'main:dataprivacy:datadelettion:success',
      page: 'main:dataprivacy:datadelettion:success',
      link: 'done',
      comp: 'deletion_done',
    },
  },
  ZETTLE_DSR: {
    IMPRESSION: {
      pgrp: 'main:dataprivacy:zettledsr',
      page: 'main:dataprivacy:zettledsr',
    },
    GETSTARTED_BTN: {
      pgrp: 'main:dataprivacy:zettledsr',
      page: 'main:dataprivacy:zettledsr',
      link: 'get_started',
    },
    ZETTLE_EU_LINK: {
      pgrp: 'main:dataprivacy:zettledsr',
      page: 'main:dataprivacy:zettledsr',
      link: 'go_to_zettle_eu',
    },
    CASECREATION_IMPRESSION: {
      pgrp: 'main:dataprivacy:zettledsr:casecreation',
      page: 'main:dataprivacy:zettledsr:casecreation',
    },
    SUBMIT_BTN: {
      pgrp: 'main:dataprivacy:zettledsr:casecreation',
      page: 'main:dataprivacy:zettledsr:casecreation',
      link: 'submit',
    },
    PRIVACY_LINK: {
      pgrp: 'main:dataprivacy:zettledsr:casecreation',
      page: 'main:dataprivacy:zettledsr:casecreation',
      link: 'privacy_statement',
    },
    CASECREATION_SUCCESS_IMPRESSION: {
      pgrp: 'main:dataprivacy:zettledsr:success',
      page: 'main:dataprivacy:zettledsr:success',
    },
    CASECREATION_SUCCESS_LINKCLICK: {
      pgrp: 'main:dataprivacy:zettledsr:success',
      page: 'main:dataprivacy:zettledsr:success',
      link: 'request_again',
    },
    EMAILVERIFICATION_IMPRESSION: {
      pgrp: 'main:dataprivacy:zettledsr:emailverification',
      page: 'main:dataprivacy:zettledsr:emailverification',
    },
    EMAILVERIFICATION_SUCCESS_IMPRESSION: {
      pgrp: 'main:dataprivacy:zettledsr:emailverification:success',
      page: 'main:dataprivacy:zettledsr:emailverification:success',
    },
    EMAILVERIFICATION_SUCCESS_LINKCLICK: {
      pgrp: 'main:dataprivacy:zettledsr:emailverification:success',
      page: 'main:dataprivacy:zettledsr:emailverification:success',
      link: 'request_again',
    },
    EMAILVERIFICATION_EXPIRED_IMPRESSION: {
      pgrp: 'main:dataprivacy:zettledsr:emailverification:expired',
      page: 'main:dataprivacy:zettledsr:emailverification:expired',
    },
    EMAILVERIFICATION_EXPIRED_LINKCLICK: {
      pgrp: 'main:dataprivacy:zettledsr:emailverification:expired',
      page: 'main:dataprivacy:zettledsr:emailverification:expired',
      link: 'request_again',
    },
    EMAILVERIFICATION_ERROR_IMPRESSION: {
      pgrp: 'main:dataprivacy:zettledsr:emailverification:error',
      page: 'main:dataprivacy:zettledsr:emailverification:error',
    },
    EMAILVERIFICATION_RETRY_BTN: {
      pgrp: 'main:dataprivacy:zettledsr:emailverification:error',
      page: 'main:dataprivacy:zettledsr:emailverification:error',
      link: 're-try',
    },
    VERIFICATION_CLOSED_ERROR_IMPRESSION: {
      pgrp: 'main:dataprivacy:zettledsr:emailverification:closed',
      page: 'main:dataprivacy:zettledsr:emailverification:closed',
    },
    VERIFICATION_CLOSED_NEWREQUEST_LINK: {
      pgrp: 'main:dataprivacy:zettledsr:emailverification:closed',
      page: 'main:dataprivacy:zettledsr:emailverification:closed',
      link: 'make-a-new-request',
    },
  },
  SEARCH_PRIVACY: {
    PROFILE_TOGGLE: {
      pgrp: 'main:dataprivacy:profiles:search',
      page: 'main:dataprivacy:profiles:search',
    },
  },
  SHOPPING: {
    IMPRESSION: {
      pgrp: 'main:dataprivacy:shopping',
      page: 'main:dataprivacy:shopping',
    },
    TURNON_BTN: {
      pgrp: 'main:dataprivacy:shopping',
      page: 'main:dataprivacy:shopping',
      link: 'turnon',
    },
    TURNOFF_BTN: {
      pgrp: 'main:dataprivacy:shopping',
      page: 'main:dataprivacy:shopping',
      link: 'turnoff',
    },
    SUCCESS_IMPRESSION: {
      pgrp: 'main:dataprivacy:shopping:success',
      page: 'main:dataprivacy:shopping:success',
    },
    SUCCESS_DONE: {
      pgrp: 'main:dataprivacy:shopping:success',
      page: 'main:dataprivacy:shopping:success',
      link: 'done',
    },
  },
  PERSONALIZATION: {
    PAYPAL: {
      IMPRESSION: {
        pgrp: 'main:dataprivacy:personalization:paypal',
        page: 'main:dataprivacy:personalization:paypal',
      },
      OPT_TOGGLE: {
        pgrp: 'main:dataprivacy:personalization:paypal:toggle',
        page: 'main:dataprivacy:personalization:paypal:toggle',
      },
    },
    OTHER: {
      IMPRESSION: {
        pgrp: 'main:dataprivacy:personalization:other',
        page: 'main:dataprivacy:personalization:other',
      },
      OPT_TOGGLE: {
        pgrp: 'main:dataprivacy:personalization:other:toggle',
        page: 'main:dataprivacy:personalization:other:toggle',
      },
    },
  },
}
export default DATAPRIVACY_FPTI
